import React, { useEffect, useState } from 'react';
import MainContent from '../MainContent/MainContent';
import * as S from './MainLayout.styles';
import { Outlet, useLocation } from 'react-router-dom';
import { useResponsive } from '@app/hooks/useResponsive';
import { MainHeader } from '../MainHeader/MainHeader';
import { Header } from '@app/components/header/Header';
import MainSider from '../sider/MainSider/MainSider';
import { NavigationProvider } from '@app/contexts/NavigationContext';

const MainLayout: React.FC = () => {
  const [isTwoColumnsLayout, setIsTwoColumnsLayout] = useState(true);
  const [siderCollapsed, setSiderCollapsed] = useState(true);
  const { isDesktop } = useResponsive();
  const location = useLocation();
  useEffect(() => {
    setIsTwoColumnsLayout([''].includes(location.pathname) && isDesktop);
  }, [location.pathname, isDesktop]);

  const toggleSider = () => setSiderCollapsed(!siderCollapsed);

  return (
    <NavigationProvider>
      <S.LayoutMaster>
        <MainSider
          isCollapsed={siderCollapsed}
          setCollapsed={setSiderCollapsed}
        />

        <S.LayoutMain>
          <MainHeader isTwoColumnsLayout={isTwoColumnsLayout}>
            <Header
              toggleSider={toggleSider}
              isSiderOpened={!siderCollapsed}
              isTwoColumnsLayout={isTwoColumnsLayout}
            />
          </MainHeader>
          <MainContent
            id="main-content"
            $isTwoColumnsLayout={isTwoColumnsLayout}
          >
            <div>
              <Outlet />
            </div>
          </MainContent>
        </S.LayoutMain>
      </S.LayoutMaster>
    </NavigationProvider>
  );
};

export default MainLayout;
